(() => {
  if (window.__oiMightywalkDockInitialized) return;
  window.__oiMightywalkDockInitialized = true;
  const update = () => {
    const dock = document.querySelector('.oi-page .bottom-cta-dock');
    if (!dock) return;
    const visible = window.scrollY >= 1200;
    dock.classList.toggle('visible', visible);
    dock.setAttribute('aria-hidden', visible ? 'false' : 'true');
    dock.querySelectorAll('a').forEach((link) => {
      if (visible) link.removeAttribute('tabindex');
      else link.setAttribute('tabindex', '-1');
    });
  };
  window.addEventListener('scroll', update, { passive: true });
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
